import React from "react";
import NoIndex from "../../../components/NoIndex";
import { ToastContainer } from "react-toastify";

export default function EditItemModal({
  editModalOpen,
  editItem,
  setEditModalOpen,
  editForm,
  handleEditChange,
  handleImageChange,
  handleUpdateItem,
}) {
  if (!editModalOpen || !editItem) return null;

  return (
    <>
      <NoIndex />
<ToastContainer/>

      <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 montserrat-font-1">
        <div className="bg-white w-[1000px] max-h-[75vh] rounded-xl shadow-xl flex flex-col montserrat-font-1">
          {/* HEADER */}

          <div className="flex justify-between items-center border-b px-4 py-3 sticky top-0 bg-white z-10 montserrat-font-1">
            <h2 className="text-base font-semibold montserrat-font-1">
              Edit Item
            </h2>

            <button
              onClick={() => setEditModalOpen(false)}
              className="text-gray-500 hover:text-black"
            >
              ✕
            </button>
          </div>

          {/* BODY */}

          <div className="p-4 grid grid-cols-3 gap-3 overflow-y-auto flex-1 montserrat-font-1">
            <div>
              <label className="text-xs text-gray-500 mb-1 block">
                Current Image
              </label>

              <img
                src={editForm.photo}
                className="w-full h-[120px] object-contain rounded-lg mb-2"
              />

              <input
                type="file"
                onChange={handleImageChange}
                className="w-full border rounded-lg px-2 py-1.5 text-xs"
              />
            </div>

            <div className="col-span-2 grid grid-cols-2 gap-3 montserrat-font-1">
              <div>
                <label className="text-xs text-gray-500">Item Name</label>

                <input
                  name="item_name"
                  value={editForm.item_name}
                  onChange={handleEditChange}
                  className="w-full border rounded-lg px-2 py-1.5 mt-2"
                />
              </div>

              <div>
                <label className="text-xs text-gray-500">Status</label>

                <select
                  name="inStock"
                  value={editForm.inStock}
                  onChange={handleEditChange}
                  className="w-full border rounded-lg px-2 py-1.5 mt-2"
                >
                  <option value="Y">Active</option>
                  <option value="N">Inactive</option>
                </select>
              </div>

              <div className="col-span-2 grid grid-cols-4 gap-3 montserrat-font-1">
                <div className="col-span-4">
                  <label className="text-xs text-gray-500 mb-1 block">
                    Description
                  </label>

                  <textarea
                    name="item_description"
                    value={editForm.item_description}
                    onChange={handleEditChange}
                    className="w-full border rounded-lg px-2 py-1.5 text-sm mt-2"
                  />
                </div>

                <div>
                  <label className="text-xs text-gray-500 mb-1 block">
                    Price
                  </label>

                  <input
                    name="price"
                    value={editForm.price}
                    onChange={handleEditChange}
                    className="w-full border rounded-lg px-2 py-1.5 text-sm mt-2"
                  />
                </div>

                <div>
                  <label className="text-xs text-gray-500 mb-1 block">
                    Discount
                  </label>

                  <input
                    name="discount"
                    value={editForm.discount}
                    onChange={handleEditChange}
                    className="w-full border rounded-lg px-2 py-1.5 text-sm mt-2"
                  />
                </div>

                <div>
                  <label className="text-xs text-gray-500 mb-1 block">
                    Discount Price
                  </label>

                  <input
                    name="discount_price"
                    value={editForm.discount_price}
                    onChange={handleEditChange}
                    className="w-full border rounded-lg px-2 py-1.5 text-sm mt-2"
                  />
                </div>

                <div>
                  <label className="text-xs text-gray-500 mb-1 block">
                    Rating
                  </label>

                  <input
                    name="ratings"
                    value={editForm.ratings}
                    onChange={handleEditChange}
                    className="w-full border rounded-lg px-2 py-1.5 text-sm mt-2"
                  />
                </div>
              </div>
            </div>

            <div className="col-span-3 montserrat-font-1">
              <label className="text-xs text-gray-500">Photo URL</label>

              <input
                name="photo"
                value={editForm.photo}
                onChange={handleEditChange}
                className="w-full border rounded-lg px-2 py-1.5 mt-2"
              />
              <span className="text-xs text-gray-500">
                If you pick a new image above, it will upload and override this
                URL.
              </span>
            </div>

            <div className="col-span-3 grid grid-cols-2 gap-3 montserrat-font-1">
              <div>
                <label className="text-xs text-gray-500">Size</label>
                <input
                  name="size"
                  value={editForm.size}
                  onChange={handleEditChange}
                  className="w-full border rounded-lg px-2 py-1.5 mt-2"
                />
              </div>

              <div>
                <label className="text-xs text-gray-500">Barcode Number</label>
                <input
                  name="barcodeNumber"
                  value={editForm.barcodeNumber}
                  onChange={handleEditChange}
                  className="w-full border rounded-lg px-2 py-1.5 mt-2"
                />
              </div>
            </div>

            <div className="col-span-3 grid grid-cols-3 gap-3 montserrat-font-1">
              <div>
                <label className="text-xs text-gray-500">In Stock</label>
                <select
                  name="inStock"
                  value={editForm.inStock}
                  onChange={handleEditChange}
                  className="w-full border rounded-lg px-2 py-1.5 mt-2"
                >
                  <option value="Y">Yes</option>
                  <option value="N">No</option>
                </select>
              </div>

              <div>
                <label className="text-xs text-gray-500">Stock</label>
                <input
                  name="stock"
                  value={editForm.stock}
                  onChange={handleEditChange}
                  className="w-full border rounded-lg px-2 py-1.5 mt-2"
                />
              </div>

              <div>
                <label className="text-xs text-gray-500">Item Category</label>
                <input
                  name="item_category"
                  value={editForm.item_category}
                  onChange={handleEditChange}
                  className="w-full border rounded-lg px-2 py-1.5 mt-2"
                />
              </div>
            </div>

            <div className="col-span-3 grid grid-cols-3 gap-3 montserrat-font-1">
              <div>
                <label className="text-xs text-gray-500">Home Delivery</label>
                <select
                  name="home_delivery"
                  value={editForm.home_delivery}
                  onChange={handleEditChange}
                  className="w-full border rounded-lg px-2 py-1.5 mt-2"
                >
                  <option value="Y">Yes</option>
                  <option value="N">No</option>
                </select>
              </div>

              <div>
                <label className="text-xs text-gray-500">Takeaway</label>
                <select
                  name="takeaway"
                  value={editForm.takeaway}
                  onChange={handleEditChange}
                  className="w-full border rounded-lg px-2 py-1.5 mt-2"
                >
                  <option value="Y">Yes</option>
                  <option value="N">No</option>
                </select>
              </div>

              <div>
                <label className="text-xs text-gray-500">Dining</label>
                <select
                  name="dining"
                  value={editForm.dining}
                  onChange={handleEditChange}
                  className="w-full border rounded-lg px-2 py-1.5 mt-2"
                >
                  <option value="Y">Yes</option>
                  <option value="N">No</option>
                </select>
              </div>
            </div>

            <div className="col-span-3 grid grid-cols-3 gap-3 montserrat-font-1">
              <div>
                <label className="text-xs text-gray-500">Name Trans</label>
                <input
                  name="item_name_trans"
                  value={editForm.item_name_trans}
                  onChange={handleEditChange}
                  className="w-full border rounded-lg px-2 py-1.5 mt-2"
                />
              </div>

              <div>
                <label className="text-xs text-gray-500">Desc Trans</label>
                <input
                  name="item_description_trans"
                  value={editForm.item_description_trans}
                  onChange={handleEditChange}
                  className="w-full border rounded-lg px-2 py-1.5 mt-2"
                />
              </div>

              <div>
                <label className="text-xs text-gray-500">Size Trans</label>
                <input
                  name="size_trans"
                  value={editForm.size_trans}
                  onChange={handleEditChange}
                  className="w-full border rounded-lg px-2 py-1.5 mt-2"
                />
              </div>
            </div>

            <div className="col-span-3 montserrat-font-1">
              <label className="text-xs text-gray-500">
                Icon Dish (string / JSON string)
              </label>

              <input
                name="icon_dish"
                value={editForm.icon_dish}
                onChange={handleEditChange}
                className="w-full border rounded-lg px-2 py-1.5 mt-2"
              />
            </div>
          </div>

          {/* FOOTER */}

          <div className="flex justify-end gap-2 border-t px-4 py-3 sticky bottom-0 montserrat-font-1 bg-white montserrat-font-1">
            <button
              onClick={() => setEditModalOpen(false)}
              className="border px-3 py-1.5 rounded-lg text-sm "
            >
              Cancel
            </button>

            <button
              onClick={handleUpdateItem}
              className="bg-emerald-500 hover:bg-emerald-600 text-white px-4 py-1.5 rounded-lg text-sm"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
